"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const giftcardbrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-giftcardbrand03` : '') + (description ? ` desc-giftcardbrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-giftcardbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-giftcardbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.758 5.155h57.267a3.685 3.685 0 0 1 3.684 3.686v35.473A3.685 3.685 0 0 1 67.025 48H9.758a3.685 3.685 0 0 1-3.684-3.686V8.84a3.685 3.685 0 0 1 3.684-3.686Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.605 2.922a2.685 2.685 0 0 0-2.684 2.686V41.08a2.685 2.685 0 0 0 2.684 2.687h57.267a2.685 2.685 0 0 0 2.684-2.687V5.608a2.685 2.685 0 0 0-2.684-2.686H5.605ZM.921 5.608A4.685 4.685 0 0 1 5.605.922h57.267a4.685 4.685 0 0 1 4.684 4.686V41.08a4.685 4.685 0 0 1-4.684 4.687H5.605A4.685 4.685 0 0 1 .921 41.08V5.608Z",
    fill: "#F04C24"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.109 22.525a1 1 0 0 1 1.414 0l7.441 7.446a1 1 0 1 1-1.414 1.414l-7.442-7.445a1 1 0 0 1 0-1.415Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.523 22.525a1 1 0 0 1 0 1.415l-7.441 7.445a1 1 0 0 1-1.415-1.414l7.441-7.445a1 1 0 0 1 1.415 0Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.349 17.03a2.784 2.784 0 0 0-3.363.443l-4.757 4.76h6.727a2.79 2.79 0 0 0 1.393-5.203Zm-4.778-.97a4.785 4.785 0 0 1 5.778-.762 4.79 4.79 0 0 1-2.393 8.935h-9.14a1 1 0 0 1-.708-1.707l6.463-6.467Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m16.06 16.06 6.463 6.466a1 1 0 0 1-.707 1.707h-9.14a4.79 4.79 0 0 1-2.394-8.935 4.785 4.785 0 0 1 5.778.761Zm-1.415 1.413a2.784 2.784 0 0 0-3.363-.444 2.79 2.79 0 0 0 1.393 5.204h6.727l-4.757-4.76Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.325 22.344h63.827v2H2.325v-2Z",
    fill: "#F04C24"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.716 45.17V2.327h2V45.17h-2Z",
    fill: "#F04C24"
  }));
};
var _default = exports.default = giftcardbrand03;